var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelegramColor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Telegram_logo 1",
    clipPath: "url(#clip0_1904_7717)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "url(#paint0_linear_1904_7717)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.12109 12.8773L9.54479 16.8179C9.54479 16.8179 9.72279 17.1866 9.91339 17.1866C10.104 17.1866 12.9389 14.2374 12.9389 14.2374L16.0914 8.14844L8.17189 11.8601L8.12109 12.8773Z",
    fill: "#C8DAEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.0125 13.8906L9.73916 16.7952C9.73916 16.7952 9.62476 17.6852 10.5146 16.7952C11.4044 15.9052 12.2561 15.2189 12.2561 15.2189",
    fill: "#A9C6D8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M8.1492 13.0163L5.2206 12.0621C5.2206 12.0621 4.8706 11.9201 4.9833 11.5981C5.0065 11.5317 5.0533 11.4752 5.1933 11.3781C5.8422 10.9258 17.2039 6.84213 17.2039 6.84213C17.2039 6.84213 17.5247 6.73403 17.7139 6.80593C17.7607 6.82042 17.8028 6.84708 17.8359 6.88318C17.8691 6.91929 17.892 6.96355 17.9024 7.01143C17.9228 7.09599 17.9314 7.183 17.9278 7.26993C17.9269 7.34513 17.9178 7.41483 17.9109 7.52413C17.8417 8.64063 15.7709 16.9734 15.7709 16.9734C15.7709 16.9734 15.647 17.461 15.2031 17.4777C15.094 17.4813 14.9853 17.4628 14.8835 17.4234C14.7817 17.384 14.6889 17.3245 14.6106 17.2485C13.7395 16.4992 10.7287 14.4758 10.0634 14.0308C10.0484 14.0206 10.0358 14.0073 10.0263 13.9917C10.0169 13.9762 10.0109 13.9589 10.0088 13.9408C9.9995 13.8939 10.0505 13.8358 10.0505 13.8358C10.0505 13.8358 15.2931 9.17583 15.4326 8.68663C15.4434 8.64873 15.4026 8.63003 15.3478 8.64663C14.9996 8.77473 8.9634 12.5866 8.2972 13.0073C8.24924 13.0218 8.19856 13.0249 8.1492 13.0163Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1904_7717",
    x1: 12,
    y1: 24,
    x2: 12,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D93D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38B0E3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1904_7717"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramColor);
export default __webpack_public_path__ + "static/media/telegram-color.2ea6b04cab4e89e224bee29f7294a08a.svg";
export { ForwardRef as ReactComponent };